import { BLACK_800, BLACK_900, RED_200, RED_400, LILAC_400, LILAC_800, GREEN_200, GREEN_400, YELLOW_200, YELLOW_400, WHITE } from './../colors';
var toastConfig = {
  theme: 'light',
  show: true,
  width: 335,
  title: '',
  dismissDuration: null,
  onDismissHandler: () => null,
  state: 'default',
  iconName: '',
  position: 'none',
  version: 'variable-width',
  showNotifier: false,
  notifierSize: 'md',
  notifierNumber: 1,
  verticalOffset: 0,
  config: {
    state: {
      default: {
        backgroundColor: BLACK_800,
        borderColor: BLACK_900,
        titleColor: WHITE,
        iconProps: {
          fontSize: 20,
          color: WHITE
        }
      },
      success: {
        backgroundColor: GREEN_200,
        borderColor: GREEN_400,
        titleColor: BLACK_900,
        iconProps: {
          fontSize: 20,
          color: BLACK_900
        }
      },
      error: {
        backgroundColor: RED_200,
        borderColor: RED_400,
        titleColor: BLACK_900,
        iconProps: {
          fontSize: 20,
          color: BLACK_900
        }
      },
      warning: {
        backgroundColor: YELLOW_200,
        borderColor: YELLOW_400,
        titleColor: BLACK_900,
        iconProps: {
          fontSize: 20,
          color: BLACK_900
        }
      },
      lilac: {
        backgroundColor: LILAC_400,
        borderColor: LILAC_800,
        titleColor: BLACK_900,
        iconProps: {
          fontSize: 20,
          color: BLACK_900
        }
      }
    }
  }
};
export default {
  light: toastConfig,
  dark: toastConfig,
  white: toastConfig
};